import { KeyValue }                 from '@angular/common';
import { Caisse }                   from '@shared/classes/caisse';
import { User }                     from '@shared/classes/user';
import { ESTATE_FORMULE }           from '@shared/enums/ESTATE_FORMULE';
import { FormuleEnum }              from '@shared/enums/formule.enum';
import { ProfilEnum }               from '@shared/enums/profil.enum';
import { ViewCaseEnum }             from '@shared/enums/viewCase.enum';
import { QueryParams }              from 'src/app/shared/queryParams/queryParams';
import { PRECO_COLUMN_LEFT }        from '../../oav-phase-b/preconisation/preconisation-oav.constants';
import { PreconisationOavHelper }   from '../../oav-phase-b/preconisation/preconisation-oav.helper';
import { HeaderSelfcareParameters } from '../../self-care/header-selfcare/header-selfcare-parameters';
import { EXPANSION_PRODUCT }        from '../../steps/step-five/expansion-product/expansion-product.constants';
import { FormuleProduct }           from '../../steps/step-five/formule-product';
import { StepEstimation }           from '../../steps/step-five/stepEstimation';
import { CHECK_PRODUCT_FOR_VIEWS }  from '../../steps/step-two/views.constants';

import { HEADER_SELFCARE, TARIFICATION_SELFCARE, TypeHeaderParameters, TypeLoadDatasTarification, TypeTarificationParametersPhaseB } from './preconisation-selfcare.constants';

export class PreconisationSelfcareHelper {

  static load (user: User, queryParams: QueryParams, event: KeyValue<string, boolean>[], caisse: Caisse): TypeLoadDatasTarification {
    const arTypeHeaderParameters     = new Array<TypeHeaderParameters> ();
    const headerSelfcare             = new Array<HeaderSelfcareParameters> ();
    let tarificationsParameters      = new Array<TypeTarificationParametersPhaseB> ();
    let listFormulesExpansionProduct = new Array<FormuleProduct> ();
    PreconisationOavHelper.formatFormuleToElligible (FormuleEnum.LEFT, PRECO_COLUMN_LEFT, user, queryParams, ProfilEnum.SELFCARE).map (r => {
      const result = event.find (e => e.key === r.id);
      let selected = true;
      if (result) {
        selected = result.value;
      }
      if ([ESTATE_FORMULE.CHECKED].includes (r.isElligible)) {
        const headerData   = HEADER_SELFCARE[r.id];
        const valuesHeader = headerData (caisse);
        const header       = {
          ...valuesHeader,
          key: r.id,
        };
        if (selected) {
          header.selected = true;

          const formuleProduct = EXPANSION_PRODUCT[r.id];
          if (!header || !formuleProduct) {
            throw `Error on HEADER_SELFCARE -> id [${r.id}] does not exist on list constants`;
          }

          const tarification = TARIFICATION_SELFCARE[r.id];
          if (!tarification) {
            throw `Error on HEADER_SELFCARE tarification -> id [${r.id}] does not exist on list constants`;
          }

          tarificationsParameters = tarificationsParameters.concat (tarification (user, caisse));
          listFormulesExpansionProduct.push ({ id: r.id, ...formuleProduct (StepEstimation.PACKAGEE) });
          headerSelfcare.push ({
                                 key:   r.id,
                                 value: selected,
                               });
        }
        arTypeHeaderParameters.push (header);

      }
    });

    return {
      arTypeHeaderParameters,
      headerSelfcare,
      listFormulesExpansionProduct,
      tarificationsParameters,
    };
  };

  static isEligibleEmprunt (user: User): boolean {
    let isEligible = false;
    if (CHECK_PRODUCT_FOR_VIEWS[ViewCaseEnum.EMPRUNTEUR_REPRISE] (user)) {
      isEligible = true;
    }
    return isEligible;
  }

}
